<template>
  <div>
    <page-heading-info
    title="Jefferson County - Dillonvale Court"
    phone="(740) 769-2903"
    fax="(740) 769-7640"
    hours="8:00 - 4:00 (M-F)"
    >
      <address-simple
      line1="174 Smithfield St."
      line3="Dillonvale, OH 43917"
      ></address-simple>
    </page-heading-info>

    <text-box-title title="General Info">
      <div class="col-md-6 mt-3">
        <p>
          Use the Court Case lookup to both look up cases, and pay fines. Select the court that
          issued your citation, and follow the instructions to send payment.
        </p>
        <p class="text-bold">
          Court contact: Amanda Tester
        </p>
      </div>

      <div class="col-md-6 mt-3">
        <text-box-title
          title=""
          icon=""
          align="left"
          block="true"
          title-bg="warning-02"
          class="padding-bootstrap">
          
            <div class="col">
              <div class="mb-3">
                Due to the COVID-19 virus, anyone entering the court is now required by the state to wear 
                a face mask. Please contact this court if you have any questions.
              </div>
            </div>

          </text-box-title>
        <link-box
        bg-color="dark"
        dark="true"
        icon="payment"
        icon-color="light"
        title-color="light"
        title="Court Case Lookup / Make Payments"
        title-align="left"
        url="https://cv.jeffcch.com/">
          Look up Dillonvale court cases and make payments here
        </link-box>
      </div>
    </text-box-title>

    <text-box-title title="Rules of Court">
      <note-documents note-id="25" class="ml-3 mr-3 mt-3"></note-documents>
    </text-box-title>

    <text-box-title title="Dillonvale Court Documents">
      <note-documents note-id="59" class="ml-3 mr-3 mt-3"></note-documents>
    </text-box-title>

  </div>
</template>

<script>
import PageHeadingInfo from '@/components/layout/PageHeadingInfo.vue'
import AddressSimple from '@/components/display-utils/AddressSimple.vue'
import TextBoxTitle from '@/components/layout/TextBoxTitle.vue'
import NoteDocuments from '@/components/display-utils/NoteDocuments.vue'
import LinkBox from '@/components/layout/LinkBox.vue'

export default {
  components: {
    PageHeadingInfo,
    AddressSimple,
    TextBoxTitle,
    NoteDocuments,
    LinkBox
  },
  data () {
    return {}
  }
}
</script>

<style scoped>
  .court-lookup {
    font-size: 1.5em;
    font-weight: bold;
  }

  .court-lookup:hover {
    opacity: 0.7;
  }

</style>
